import { EnumCheckboxFieldProps } from "./EnumCheckboxField";
import React, { useEffect } from "react";
import { EnumCheckboxFieldValue } from "../../types/fieldTypes";

export const useEnumCheckboxField = (props: EnumCheckboxFieldProps) => {
  const [localValues, setLocalValues] = React.useState<EnumCheckboxFieldValue>(
    props.value
  );

  useEffect(() => {
    setLocalValues(props.value);
  }, [props.value]);

  return { localValues, setLocalValues };
};
